import * as React from "react";
import type { SVGProps } from "react";
const SvgEmailClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    viewBox="0 0 16 17" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.333 12.492H4.667A2.667 2.667 0 0 1 2 9.826V5.159a2.667 2.667 0 0 1 2.667-2.667h6.666A2.667 2.667 0 0 1 14 5.16v2"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.667 5.492 7.47 6.715c.338.147.723.148 1.062.001l2.801-1.211"
    />
    <circle
      cx={12}
      cy={11.826}
      r={2.667}
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.807 10.842v1.166h1"
    />
  </svg>
);
export default SvgEmailClock;
